<template>
    <div class="clearfix w980">
        <div class="v100 weizhi fs12">
            首页 - 产品 - 刷机大师(手机版)</div>
        <product-menu now="andromaster" />
        <div class="v100 bigimg mt20">
            <img alt="刷机大师(手机版)" src="@/assets/images/andromaster_0120.jpg"/>
            <div class="brand">
				<img src="@/assets/images/sjds.jpg" alt="刷机大师（手机版）" height="75" width="121" />
			</div>
            <h1 style="display:block;position:absolute;left:-5999px">刷机大师（手机版）</h1>
        </div>
        <div class="v100 gongneng">
            <dl>
                <img alt="刷机大师手机版，首创“离线”刷机" class="fl" src="@/assets/images/Ray22.jpg" />
                <dt class="fr">首创“离线”刷机</dt>
                <dd class="fr">
                    无需电脑、无需数据线、告别繁琐程序，直接在手机端刷机</dd>
            </dl>
            <dl>
                <img alt="刷机大师手机版，直接手机下载万千ROM" class="fr" src="@/assets/images/Ray23.jpg" />
                <dt class="fl">万千ROM，乐享一键刷机</dt>
                <dd class="fl">
                    汇聚ROM基地精品ROM免费下载</dd>
            </dl>
            <dl>
                <img alt="刷机大师手机版，精品工具箱，刷机备份、优化管理，小手机、大体验" class="fl" src="@/assets/images/Ray24.jpg" />
                <dt class="fr">精品工具箱</dt>
                <dd class="fr">
                    刷机备份、优化管理，小手机、大体验</dd>
            </dl>
            <dl>
                <img alt="刷机大师手机版，官方ROM、热门团队，编辑推荐，精品ROM，每周更新" class="fr" src="@/assets/images/Ray25.jpg" />
                <dt class="fl">编辑推荐，精品更新</dt>
                <dd class="fl">
                    官方ROM、热门团队，编辑推荐，精品ROM，每周更新</dd>
            </dl>
            <dl>
                <img alt="刷机大师手机版，界面清新、简洁美观，上手简单" class="fl" src="@/assets/images/Ray26.jpg" />
                <dt class="fr">全新界面，简约易上手</dt>
                <dd class="fr">
                    界面清新、简洁美观，上手简单</dd>
            </dl>
        </div>
    </div>
</template>

<script>
import ProductMenu from "@/components/function/ProductMenu";
export default {
  name: "andromaster",
  components: {
    ProductMenu
  }
};
</script>



// WEBPACK FOOTER //
// src/components/function/andromaster.vue